var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"globalspin",staticClass:"globalspin"},[_c('a-spin',{staticStyle:{"margin-top":"350px"},attrs:{"tip":_vm.tip,"spinning":_vm.spinning,"size":"large"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }